<script>
	export let priority;
	export let task;
	export let config;

</script>

<div class="wx-todo_list__priority">
	{#if config?.label}
		<div
			class="wx-todo_list__priority-label"
			style="background:{priority[task.priority]?.color};" />
	{/if}
	{#if config?.cover}
		<div
			class="wx-todo_list__priority-cover"
			style="background:{priority[task.priority]?.color};" />
	{/if}
</div>

<style>
	.wx-todo_list__priority {
		display: flex;
		position: absolute;
		top: 0;
		left: 0;

		width: 100%;
		height: 100%;

		z-index: 0;
	}
	.wx-todo_list__priority-label {
		height: 100%;
		width: 4px;
	}
	.wx-todo_list__priority-cover {
		width: 100%;
		height: 100%;

		opacity: 0.1;
	}

</style>
